import { render, staticRenderFns } from "./VisionboardSidebar.vue?vue&type=template&id=4cb4e9aa&"
import script from "./VisionboardSidebar.vue?vue&type=script&lang=js&"
export * from "./VisionboardSidebar.vue?vue&type=script&lang=js&"
import style0 from "./VisionboardSidebar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports